import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import BetaCodeValidation from './BetaCodeValidation';
import MinimalFooter from '@/components/MinimalFooter';
import Header from '@/components/Header';

export default function BetaCodeRequired() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header onStartTour={() => {}} showChat={false} />

      <main className="flex-1 container mx-auto px-4 py-12">
        <div className="max-w-md mx-auto space-y-6">
          <div className="text-center space-y-2">
            <h1 className="text-3xl font-bold">Welcome to BinauralFlow</h1>
            <p className="text-muted-foreground">
              We're currently in beta and require an invite code to access the app.
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle>Beta Access Required</CardTitle>
              <CardDescription>
                Please enter your beta access code to continue.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <BetaCodeValidation />
            </CardContent>
          </Card>

          <div className="text-center">
            <Button asChild variant="outline">
              <a href="https://binauralflow.ai/signup" target="_blank" rel="noopener noreferrer">
                Join the Waiting List
              </a>
            </Button>
          </div>
        </div>
      </main>

      <MinimalFooter />
    </div>
  );
} 